<div class="flex">
  <sbnb-subnav class="w-[280px] hidden md:block" [header]="'OPERATIONS.OPERATIONS' | transloco">
    <sbnb-operations-subnav></sbnb-operations-subnav>
    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'statements-adjustments'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main class="flex-1 subnav__exists">
    <div class="mb-6 text-night">
      <h1 class="text-2xl font-bold">Adjustments</h1>
      <p class="mt-2">
        Review the suggestions below to determine how to handle financial adjustments made to the reservation.
      </p>
    </div>

    <!-- filters -->
    <div>
      <sbnb-filter
        customEndpoint="/operations/v2/reservation-adjustments/filters"
        [sortByLabel]="false"
        [hideSaveSegment]="true"
        [defaultFilters]="activeFilters$ | async"
        (filterChanged)="activeFilters$.next($event)"
        (reset)="activeFilters$.next([])"></sbnb-filter>
    </div>

    <sbnb-statements-adjustments-table
      *ngIf="state$ | async as state"
      [previewedAdjustment]="previewedAdjustment$ | async"
      (pageChanged)="onPageChange($event)"
      (adjustmentSelected)="onAdjustmentSelected($event)"
      (adjustmentApplied)="onAdjustmentApplied()"></sbnb-statements-adjustments-table>
  </main>

  <sbnb-mobile-sidebar [title]="'Operations'">
    <sbnb-operations-subnav></sbnb-operations-subnav>
  </sbnb-mobile-sidebar>
</div>
